module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "name": "demo-validate-required-when-exist"
    }
  }, [_c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:timend|date_format:HH:mm'),
      expression: "'requiredWhenExist:timend|date_format:HH:mm'"
    }],
    attrs: {
      "data-vv-value-path": "inputTime",
      "data-vv-name": "timstrt",
      "name": "timstrt",
      "has-error": _vm.errors.has('timstrt')
    },
    model: {
      value: (_vm.timstrt),
      callback: function($$v) {
        _vm.timstrt = $$v
      },
      expression: "timstrt"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timstrt')),
      expression: "errors.has('timstrt')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timstrt')))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredWhenExist:timstrt|date_format:HH:mm'),
      expression: "'requiredWhenExist:timstrt|date_format:HH:mm'"
    }],
    attrs: {
      "data-vv-value-path": "inputTime",
      "data-vv-name": "timend",
      "name": "timend",
      "has-error": _vm.errors.has('timend')
    },
    model: {
      value: (_vm.timend),
      callback: function($$v) {
        _vm.timend = $$v
      },
      expression: "timend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timend')),
      expression: "errors.has('timend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timend')))])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-00a7b7b0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/demo/demoValidateRequiredWhenExist.vue
// module id = 3500
// module chunks = 1